import { render, staticRenderFns } from "./LegalNotice.vue?vue&type=template&id=67cce3ba&scoped=true"
import script from "./LegalNotice.vue?vue&type=script&lang=js"
export * from "./LegalNotice.vue?vue&type=script&lang=js"
import style0 from "./LegalNotice.vue?vue&type=style&index=0&id=67cce3ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67cce3ba",
  null
  
)

export default component.exports